// NOTE: These models are only used in the account triage component and its children
export enum TriageAccountType {
  EMPTY = '',
  INDV = 'INDV',
  JOINT = 'JOINT',
  TRADITIONAL_IRA = 'TRADITIONAL_IRA',
  ROTH_IRA = 'ROTH_IRA',
  INHERITED_TRADITIONAL_IRA = 'INHERITED_TRADITIONAL_IRA',
  INHERITED_ROTH_IRA = 'INHERITED_ROTH_IRA',
}

export enum TriageAccountTypeNames {
  EMPTY = '',
  INDV = 'Individual',
  JOINT = 'Joint',
  TRADITIONAL_IRA = 'Traditional, SEP, or rollover IRA',
  ROTH_IRA = 'Roth IRA',
  INHERITED_TRADITIONAL_IRA = 'Inherited IRA',
  INHERITED_ROTH_IRA = 'Inherited Roth IRA',
}
